export class RefreshTokenRequest {
  public token: string;
  public refreshToken: string;
  public userType: number;
}
